






































































































import { computed, defineComponent, onMounted, ref, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getFirstPriceLabel, getSecondPriceLabel, getAdditionalPriceLabel, getHasScalapay } from '~/utils/helpers/product';
import AddToCart from '~/components/solepro/AddToCart.vue';
import PaymentFrequencySwitcher from './PaymentFrequencySwitcher.vue';
import { ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS, SIMPLE_TYPE_ID, TIPO_RINNOVO_AUTOMATICO, VIRTUAL_TYPE_ID } from '~/utils/constants/product';
import ConfigureBundle from './ConfigureBundle.vue';
import { useConfig, useUiState } from '~/composables';
import ClientOnly from 'vue-client-only';
import CrossSellModal from '../CrossSellModal.vue';


export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        },
        useCarousel: {
            default: false
        },
        changeFrequencyCbk: {
            type: Function,
            default: () => { }
        },
        betterOffer: {
            type: Object as PropType<ProductForProductPageType>,
            required: false
        },
        suggestedSku: {
            type: String
        },
        showFrequencies: {
            type: Boolean,
            deafault: true
        },
        showSuggestedSku: {
            type: Boolean,
            deafault: false
        }

    },
    components: {
        AddToCart,
        PaymentFrequencySwitcher,
        ConfigureBundle,
        ClientOnly,
        CrossSellModal
    },
    data() {
        return {
            hasFrequencies: false
        }
    },
    setup(props) {
        const { app: { i18n }, $fc } = useContext();
        const { product } = props;
        const crossSellModal = ref(null)
        const pf = product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO ? (product.entryBillingPeriod ?? product.paymentFrequencies[product.paymentFrequencies.length - 1]) : null
        const paymentFrequencyChoosen = ref(pf)

        const firstPriceLabel = ref()
        const secondPriceLabel = ref()
        const addictionalLabel = ref()
        const productConfiguration = ref({ [props.product.sku]: product.hasPaperToAdd ? { shippingType: 'Posta' } : null }  /*@TODO check used to manage bundle-gpf*/)
        const modulesToAdd = ref<String[]>([])
        const tipoConsegna = product.hasPaperToAdd ? 'posta' : null; //@TODO check
        const priceLabels = computed(() => [firstPriceLabel.value, secondPriceLabel.value])
        const changeFrequency = (frequency) => {
            props.changeFrequencyCbk(product, frequency)
            paymentFrequencyChoosen.value = frequency;
            setLabels()
        }

        const setLabels = () => {
            const ivaSuffix = product.includes_iva ? '' : ' + IVA';
            firstPriceLabel.value = getFirstPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc) + ivaSuffix;
            const isVirtualRecurring = (product.tipo_rinnovo == TIPO_RINNOVO_AUTOMATICO && (product.productTypeId == VIRTUAL_TYPE_ID || product.productTypeId == SIMPLE_TYPE_ID))
            const tmpSecondPriceLabel = getSecondPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc, 0, 0, isVirtualRecurring)
            secondPriceLabel.value = tmpSecondPriceLabel && tmpSecondPriceLabel.trim() != '' ? tmpSecondPriceLabel + ivaSuffix : tmpSecondPriceLabel;
            addictionalLabel.value = getAdditionalPriceLabel(product, paymentFrequencyChoosen.value, i18n, $fc)
        }

        setLabels()

        changeFrequency(paymentFrequencyChoosen.value)

        if (product.requiredModules.length > 0) {
            product.requiredModules.forEach(module => modulesToAdd.value.push(module.product.sku))
        }

        const sanitizedSku = product.sku + '"]'.replace(/\./g, '').replace(/ /g, '-')

        const cardsQty = ref(0);
        onMounted(() => {
            cardsQty.value = Array.from(document.querySelectorAll('[data-component="productPurchaseOptions"]')).length
        })

        let addToCartBtns = ['Aggiungi al carrello'];
        if (product.directCheckoutLabel && product.directCheckoutLabel.trim() != '') {
            addToCartBtns.push(product.directCheckoutLabel)
        } else {
            addToCartBtns.push(!!product.autoRenew ? 'Abbonati in un click' : 'Acquista in un click')
        }

        const { config: storeConfig } = useConfig();

        return {
            sku: product.sku,
            paymentFrequencyChoosen,
            ADD_TO_CART_TIPO_ABBONAMENTO_PARAMS,
            firstPriceLabel,
            secondPriceLabel,
            addictionalLabel,
            productConfiguration,
            changeFrequency,
            tipoConsegna,
            modulesToAdd,
            hasScalapay: getHasScalapay(product),
            sanitizedSku,
            scalapaySelector: '["#campaign-price-container-secondary-' + sanitizedSku + '","#campaign-price-container-' + sanitizedSku + '"]',
            cardsQty,
            addToCartBtns,
            email: storeConfig.value.general_contact_email,
            priceLabels

        }
    },
    methods: {
        openCrossSellModal() {
            // @ts-ignore
            if (this.$refs.crossSellModal && this.$refs.crossSellModal.openModal && this.$refs.crossSellModal.modalId) {
                // @ts-ignore
                this.$refs.crossSellModal.openModal(this.$refs.crossSellModal.modalId)
            }
        }
    }
})
